import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpotifyComponent } from './simple-icons-spotify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpotifyComponent ],
    exports:      [ SimpleIconsSpotifyComponent ],
    bootstrap:    []
})
export class SimpleIconsSpotifyModule {}
